import "./index.css";


export default function FetchingDataAnimation() {
  let animationData = [];
  for (let i = 0; i < 11; i++) {
    let object = {
      volume: 50,
    };
    animationData = [...animationData, object];
  }

  return (
    <div className="graph">
      {animationData.map((bar, index) => {
        if (bar.volume === 0) return null;
        return (
          <div
            key={index}
            className="bar-loader"
            style={{
              height: "50%",
              animationDelay: index * 0.06 + "s",
            }}
          ></div>
        );
      })}
    </div>
  );
}

/*
ref={(e)=> {
            function tick(timestamp:number) {
              let x = (index * timestamp);
              console.log(e)
              e.style.height = Math.sin(x) + "%";
              requestAnimationFrame(tick)
            }
            requestAnimationFrame((timestamp)=> {
              tick(timestamp);
            })
          }}
            className="bar-loader"
            style={{
              animationDelay: index * 0.02 + "s",
            }}
          >
          */
